import Vue from "vue";
import VueVirtualScroller from "vue-virtual-scroller";

import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

Vue.use(VueVirtualScroller);
